import type { FC } from 'react';
import { defineMessage, useIntl } from 'react-intl';
import { PrudsysSearchProductsRecoSlider } from '@packages/recommendations';
import { useOriginalSearchQuery } from '../../hooks/useOriginalSearchQuery';

const fallbackRDEHeadline = defineMessage({
  defaultMessage: 'Kunden, die nach "{searchQuery}" suchten, besuchten auch.',
  id: 'search.recommendation.headline',
});

/**
 * Recommendation component for search result page
 * */
export const Recommendations: FC = () => {
  const { formatMessage } = useIntl();
  const searchQuery = useOriginalSearchQuery();

  return (
    <PrudsysSearchProductsRecoSlider
      term={searchQuery}
      pageTemplate="serp"
      fetchOnThreshold
      elementIndex={0}
      title={formatMessage(fallbackRDEHeadline, { searchQuery })}
      preferTitle
    />
  );
};
